import type { ProofOfPlayRecord } from '@/types';
import { addProofOfPlay } from '@/core/offline-store';
import { logger } from '@/core/logger';

let counter = 0;

function generateId(): string {
  return `pop-${Date.now()}-${++counter}`;
}

export function recordPlayback(
  campaignId: string,
  boardId: string,
  mediaName: string,
  durationSec: number,
): void {
  const record: ProofOfPlayRecord = {
    id: generateId(),
    campaignId,
    boardId,
    mediaName,
    timestamp: new Date().toISOString(),
    duration: durationSec,
    synced: false,
  };
  addProofOfPlay(record);
  logger.debug('[ProofOfPlay] Recorded', {
    media: mediaName,
    durationSec,
  });
}
